import Resource from '@/plugins/sdk/Resource'
import { DATETIME, UUID, ITEM } from '@/plugins/sdk/fields'
import ConsignmentRule from '@/plugins/sdk/resources/Account/ConsignmentRule'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'

export default class extends Resource {
  static name = 'account_consignment_rule_service'

  static get fields () {
    return {
      id: new UUID(),
      rule: new ITEM(ConsignmentRule),
      carrier_service: new ITEM(CarrierService),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
